import './text-card.scss';
var TextCard = /** @class */ /*@__PURE__*/ (function () {
    function TextCard() {
    }
    return TextCard;
}());
export { TextCard };
